import React from "react";
import {
  Text,
  Flex,
  Button
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { getBid } from "../../lib/Auth";

const CustomizeAiHistoryHeader = ({ assisted = false }) => {
  const navigate = useNavigate();
  const bid = getBid();

  return (
    <Flex flexDirection="row" alignItems="center" width="100%" my={4}>
      <Text align="start" fontSize="sm" fontWeight="bold" mt={2} ml={2} mb={4}>
        {assisted ? "AI Setup Assistant History" : "AI Settings History"}
      </Text>
      <Flex justifyContent="flex-end" gap={2} ml='auto' my={1} mr={2} minHeight="30px" minWidth="20px" align="center">
        <Button onClick={() => navigate(`/settings/customize-ai?bid=${bid}`)}>
          Close
        </Button>
      </Flex>
    </Flex>
  )
};

export default CustomizeAiHistoryHeader;
